document.addEventListener('DOMContentLoaded', () => {
  if ($('#signDocument').length) {
    const locale = getCurrentLocale();

    App.subscription = App.cable.subscriptions.create(
      {
        channel: 'SignatureChannel',
        subscription_id: $('#signature-contribution-id').data('id'),
        locale,
      },
      {
        received(data) {
          App.subscription.unsubscribe();

          if (data.status === 'success' && data.contract_url) {
            $('.signature-pending, .signature-error').addClass('d-none');
            $('.signature-success').removeClass('d-none');
            $('#signDocument').attr('disabled', null);

            $('#signDocument').on('click', () => {
              $('#signDocument').attr('disabled', true);

              const please_wait_translations = {
                fr: 'Veuillez patienter...',
                en: 'Please wait...',
                es: 'Por favor, espere...',
              };

              $('#signDocument').text(please_wait_translations[locale]);

              const viewer = document.createElement('div');
              viewer.dataset.controller = 'pdf-viewer';
              viewer.dataset.pdfViewerSrcValue = data.contract_url;
              document.querySelector('#iframeContainerId').appendChild(viewer);

              setTimeout(() => {
                $('.signature-loader-block').addClass('d-none');
                $('.signature-block').removeClass('d-none');
              }, 1500);
            });
          } else if (data.status === 'retry') {
            $('.signature-pending, .signature-success, #signDocument').addClass('d-none');

            $('.signature-error').removeClass('d-none');
          } else {
            $('.signature-pending, .signature-success, #signDocument').addClass('d-none');

            if (data?.message) {
              $('.signature-error').html(data.message);
            }

            $('.signature-error').removeClass('d-none');
          }
        }
      }
    );
  }
});
